import { render, staticRenderFns } from "./DxPlannReal.vue?vue&type=template&id=2dd961fe&scoped=true&"
import script from "./DxPlannReal.vue?vue&type=script&lang=js&"
export * from "./DxPlannReal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd961fe",
  null
  
)

export default component.exports